import { PERMISSIONS } from './permissions.js';

/**
 * Tabs of the People & Access page, in display order. `id` is also the route segment and
 * `permission` the key that makes the tab visible (CT-5569).
 */
export const PEOPLE_ACCESS_TABS = Object.freeze([
  { id: 'members', labelKey: 'tabs.members', permission: PERMISSIONS.MEMBERS_VIEW },
  { id: 'roles', labelKey: 'tabs.roles', permission: PERMISSIONS.ROLES_VIEW },
  { id: 'groups', labelKey: 'tabs.groups', permission: PERMISSIONS.GROUPS_VIEW },
]);

/** The tab shown when the app is opened without a sub-route. */
export const DEFAULT_TAB_ID = PEOPLE_ACCESS_TABS[0].id;

/** Route segments below the People & Access mount, for building absolute links with `getBasePath`. */
export const MEMBERS_PATH = 'members';
export const MEMBERS_IMPORT_PATH = 'members/import';
